import {defineStore} from 'pinia';
import {Configuration, CompletionApi, type CompletionList} from '@api';

export const useTaskListStore = defineStore('task-list', () => {
    const apiConfiguration = new Configuration({basePath: ''});
    const completionApi = new CompletionApi(apiConfiguration);

    async function getTasks(): Promise<CompletionList> {
        return await completionApi.getCompletionList();
    }

    const CONFETTI_KEY = 'task-list-items-needs-confettis';

    function hasPendingConfetti(): boolean {
        if (!import.meta.client) return false;
        return JSON.parse(localStorage.getItem(CONFETTI_KEY) ?? '[]').length > 0;
    }

    return {
        getTasks,
        hasPendingConfetti,
    };
});
